import GoodList from "./Base/GoodList";
import SelectedList from "./Base/SelectedList";
import List from "./Base/List";

class BuyCarStore {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  list = new List([]);
  goodList = new GoodList({ list: this.list.list, checkField: "check" });
  selectedList = new SelectedList({ list: this.list.list, checkField: "check" });

  constructor() {
    console.log("constructor", this.selectedList);
    let self = this;
    this.state = {
      list: this.list.list,
      get isSelectAll() {
        return self.selectedList.state.isSelectAll;
      },
    };
  }

  //通过产品Id找到对应Item1
  _findByProductId(ProductId) {
    return this.state.list.find((it) => it.ProductId == ProductId);
  }

  //通过产品Id和仓库id找到对应Item1
  _findByProductIdAndWarehouseId(ProductId, WarehouseId) {
    return this.state.list.find((it) => it.ProductId == ProductId && it.WarehouseId == WarehouseId);
  }

  //追加元素
  _pushItem(item) {
    let clearItem = JSON.parse(JSON.stringify(item));
    this.state.list.push(clearItem);
  }

  //批量加入
  batchAdd(items) {
    if (this.debug) console.log("批量添加到购物车", items);
    items.forEach((item) => {
      let product = this._findByProductIdAndWarehouseId(item.ProductId, item.WarehouseId);
      if (product) {
        product.num += item.num;
      } else {
        this._pushItem(item);
      }
    });
    this.calcIsSelectAll();
  }

  clearSelected() {
    if (this.debug) console.log("删除购物车的选中数据");

    let { list } = this.state;
    let selected = this.selectedList.getSelected();

    selected.forEach((it) => {
      let index = list.indexOf(it);
      list.splice(index, 1);
    });
  }

  changeNum() {
    return this.goodList.changeNum.apply(this.goodList, arguments);
  }
  getSelectedLength() {
    return this.goodList.getSelectedLength.apply(this.goodList, arguments);
  }
  getSelectedAmount() {
    return this.goodList.getSelectedAmount.apply(this.goodList, arguments);
  }

  selected() {
    return this.selectedList.selected.apply(this.selectedList, arguments);
  }
  calcIsSelectAll() {
    return this.selectedList.calcIsSelectAll.apply(this.selectedList, arguments);
  }
  selectedAll() {
    return this.selectedList.selectedAll.apply(this.selectedList, arguments);
  }
  deleteSelectedItems() {
    return this.selectedList.deleteSelectedItems.apply(this.selectedList, arguments);
  }
  getSelected() {
    return this.selectedList.getSelected.apply(this.selectedList, arguments);
  }
}
export default new BuyCarStore();
